import { Link as RouterLink } from "react-router-dom";
import {
  Box,
  Card,
  Typography,
  CardContent,
  Stack,
  Breadcrumbs,
  Link,
} from "@mui/joy";
import { useTranslation } from "../../../i18n";
import Chat from "../../dash/messages/Chat";
import { useTeam } from "../TeamLayout";
import HomeIcon from "@mui/icons-material/Home";
import OnlineUsersToggle from "../../../components/OnlineUsersToggle";

export default function TeamChat() {
  const teamCtx = useTeam();
  const t = useTranslation();

  return (
    <Box
      sx={{
        height: "100dvh",
        display: "flex",
        flexDirection: "column",
        m: 0,
        p: 0,
      }}
    >
      <Stack direction="row">
        <Breadcrumbs
          aria-label="breadcrumbs"
          sx={{
            "--Breadcrumbs-gap": "4px",
            m: 1,
          }}
          size="sm"
        >
          <Link component={RouterLink} color="neutral" to="/">
            <HomeIcon />
          </Link>
          <Link
            component={RouterLink}
            color="neutral"
            to={`/${teamCtx.team.slug}`}
          >
            {teamCtx.team.name}
          </Link>
          <Typography level="title-sm">{t("Chat")}</Typography>
        </Breadcrumbs>
        <OnlineUsersToggle />
      </Stack>
      <Box
        sx={{
          flex: 1, // this fills the remaining vertical space
          m: 2,
        }}
      >
        <Card
          sx={{
            backgroundColor: "hsl(0deg 0% 31.06% / 35%);",
            height: "100%",
            padding: 0,
          }}
        >
          <Typography sx={{ pt: 1, pl: 2 }} level="title-lg">
            {teamCtx.team.name} - {t("Team Chat")}
          </Typography>
          <CardContent
            sx={{
              margin: "2px",
              borderRadius: 6,
              border: "1px solid black",
              height: "100%",
              gap: 0,
            }}
          >
            <Box
              gap={0.5}
              sx={{
                borderRadius: 6,
                flex: 1,
                width: "100%",
                mx: "auto",
              }}
            >
              {teamCtx.team.id && (
                <Chat
                  entityId={teamCtx.team.id.toString()}
                  entityType={"team"}
                />
              )}
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
}
